import axios from "axios";
import { Auth } from "aws-amplify";
import AWS_CONFIG from "./config/aws";
import AWS_CONSTANTS from "./constants/aws";
import RAZORPAY_CONSTANTS from "./config/razorpay";
import DELHIVERY_CONFIG from "./config/delhivery";

export const capitalizeSentence = (str) =>
  str
    .toLowerCase()
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.substr(1))
    .join(" ");

export const validatePassword = (password) => password.length >= 6;

export const validatePincode = (pincode) => /^[1-9][0-9]{5}$/.test(pincode);

export const validatePhoneNumber = (phoneNumber) => /\d{12}$/.test(phoneNumber);

const hasDecimal = (n) => (n - Math.floor(n) !== 0 ? true : false);

export const verifyQuantity = (quantity) => !hasDecimal(Number(quantity));

export const validateEmail = (email) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(email).toLowerCase()
  );

export function validateAddress(address) {
  const { addressLine1, pincode, state, city, alternateContact } = address;
  if (!addressLine1 || addressLine1 === "") {
    return { error: "Google Location/Locality cannot be empty" };
  }
  if (!pincode || pincode === "") {
    return { error: "Pincode cannot be empty" };
  } else {
    if (!validatePincode(pincode)) {
      return { error: "Invalid Pincode" };
    }
  }
  if (!state || state === "") {
    return { error: "State cannot be empty" };
  }
  if (!city || city === "") {
    return { error: "City cannot be empty" };
  }
  if (alternateContact && !validatePhoneNumber(alternateContact)) {
    return { error: "Invalid Alternate Contact Number" };
  }
  return true;
}

export function validateUserAttributes(userAttributes) {
  const { username, given_name, email } = userAttributes;
  if (!username || username === "") {
    return { error: "Username cannot be empty" };
  } else {
    if (!validatePhoneNumber(username)) {
      if (!validatePhoneNumber(`+91${username}`)) {
        return { error: "Invalid username/phone" };
      }
    }
  }
  if (!given_name || given_name === "") {
    return { error: "Given name cannot be empty" };
  }
  if (!email || email === "") {
    return { error: "Email cannot be empty" };
  } else {
    if (!validateEmail(email)) {
      return { error: "Email is not valid" };
    }
  }
  return true;
}

export const validateOtp = (otp) => otp.length === 6;

export const getCategories = async () =>
  await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/categories`)
    .then((result) => {
      return {
        categories: result.data.data.category_names,
        showPriceValue: result.data.data.show_price,
      };
    })
    .catch((error) => alert(error.response.data.error));

export const updateCategory = async (id, data) =>
  window.confirm(
    `Are you sure you want to update this category ${data.category_name}`
  )
    ? await axios
        .patch(`${AWS_CONSTANTS.API_URL}v1/categories/${id}`, data)
        .then(() => {
          alert("Category data updated successfully");
          return true;
        })
        .catch((error) => alert(error.response.data.error))
    : false;

export const insertCategory = async (data) =>
  window.confirm(
    `Are you sure you want to insert this category and its data: ${data.category_name}`
  )
    ? await axios
        .post(`${AWS_CONSTANTS.API_URL}v1/categories`, data)
        .then(() => {
          alert("Category Inserted Successfully");
          return true;
        })
        .catch((error) => alert(error.response.data.error))
    : false;

export const deleteCategory = async (id, name) =>
  window.confirm(`Are you sure you want to delete this category: ${name}`)
    ? await axios
        .delete(`${AWS_CONSTANTS.API_URL}v1/categories/${id}`)
        .then(() => true)
        .catch((error) => alert(error.response.data.error))
    : false;

export const deleteOrderByRazorpayOrderId = async (id) =>
  await axios.delete(`${AWS_CONSTANTS.API_URL}v1/orders/${id}`);

export async function uploadObjectS3(key, file) {
  const aws = require("aws-sdk");
  const S3 = new aws.S3({
    accessKeyId: AWS_CONFIG.ACCESS_KEY_ID,
    secretAccessKey: AWS_CONFIG.SECRET_KEY_ID,
    region: "ap-south-1",
  });
  return S3.upload({
    Bucket: AWS_CONSTANTS.ASSET_BUCKET_NAME,
    Key: key,
    ACL: AWS_CONSTANTS.S3_ACL,
    Body: file,
  })
    .promise()
    .then(() => alert("Image Uploaded Successfully"))
    .catch((error) => alert(error.response.data.error));
}

export async function updateS3FileName(oldKey, newKey) {
  const aws = require("aws-sdk");
  const S3 = new aws.S3({
    accessKeyId: AWS_CONFIG.ACCESS_KEY_ID,
    secretAccessKey: AWS_CONFIG.SECRET_KEY_ID,
    region: "ap-south-1",
  });
  S3.copyObject({
    Bucket: AWS_CONSTANTS.ASSET_BUCKET_NAME,
    CopySource: `${AWS_CONSTANTS.ASSET_BUCKET_NAME}/${oldKey}`,
    Key: newKey,
    ACL: AWS_CONSTANTS.S3_ACL,
  })
    .promise()
    .then(() =>
      S3.deleteObject({
        Bucket: AWS_CONSTANTS.ASSET_BUCKET_NAME,
        Key: oldKey,
      })
        .promise()
        .then(() => alert("Product Image Name Changed on S3"))
    )
    // Error handling is left up to reader
    .catch((e) =>
      alert("Product Image Name Not Changed. Please contact YCENT.in")
    );
}

export async function deleteObjectS3(key) {
  const aws = require("aws-sdk");
  const S3 = new aws.S3({
    accessKeyId: AWS_CONFIG.ACCESS_KEY_ID,
    secretAccessKey: AWS_CONFIG.SECRET_KEY_ID,
  });
  return S3.deleteObject({
    Bucket: AWS_CONSTANTS.ASSET_BUCKET_NAME,
    Key: key,
  })
    .promise()
    .then((result) => result)
    .catch((error) => alert(error.response.data.error));
}

export async function getProducts(queryParams) {
  var query = new URLSearchParams();
  Object.keys(queryParams).forEach((element) =>
    query.append(element, queryParams[element])
  );
  return await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/products?${query}`)
    .then((result) => result.data.data)
    .catch((error) => alert(error.response.data.error));
}

const round = (value, precision) => {
  var multiplier = Math.pow(10, precision);
  return Math.round(value * multiplier) / multiplier;
};

export function getCartAmount(cart) {
  let cartAmount = 0;
  if (cart && cart.length > 0) {
    for (var i = 0; i < cart.length; i++) {
      cartAmount += Number(
        cart[i].rate_amt
          ? round(
              (cart[i].rate_amt / 1000) * cart[i].packaging * cart[i].quantity,
              0
            ).toFixed(2)
          : Number(cart[i].price_fixed) * Number(cart[i].quantity)
      );
    }
  }
  return { cartAmount };
}

export function productWithPackagingExistsInCart(productId, packaging, cart) {
  for (var i = 0; i < cart.length; i++) {
    if (productId === cart[i].product_id && packaging === cart[i].packaging) {
      return i;
    }
  }
  return null;
}

export function productIdExistsInCart(productId, cart) {
  for (var i = 0; i < cart.length; i++) {
    if (productId === cart[i].product_id) {
      return i;
    }
  }
  return null;
}

export const userExist = (username) =>
  Auth.signIn(username, "123")
    .then(() => true)
    .catch((error) => error.code);

export const handleSignUp = async (
  username,
  given_name,
  email,
  address,
  password
) =>
  await Auth.signUp({
    username,
    password,
    attributes: {
      given_name,
      address,
      email,
    },
  }).then(() => true);

export const resendConfirmationCode = async (username) =>
  await Auth.resendSignUp(username).then(() => true);

export async function handleConfirmSignUp(username, otp) {
  return await Auth.confirmSignUp(username, otp).then(() => true);
}

export const handleForgotPassword = async (username) =>
  await Auth.forgotPassword(username);

export const handleForgotPasswordSubmit = async (username, code, password) =>
  await Auth.forgotPasswordSubmit(username, code, password).then(
    (data) => data
  );

export const handleLogin = async (username, password) =>
  await Auth.signIn(username, password).then((user) => user);

export const handleCustomAuthLogin = async (username) =>
  await Auth.signIn(username).then((user) => user);

export const handleCompleteCustomAuth = async (user, code) =>
  await Auth.sendCustomChallengeAnswer(user, code).then((user) => user);

export const getCurrentSession = async () =>
  await Auth.currentSession()
    .then((data) => data)
    .catch((err) => console.log(err));

export const getCurrentAuthenticatedUser = async (bypassCache = true) =>
  await Auth.currentAuthenticatedUser({ bypassCache })
    .then((user) => user)
    .catch((error) => console.log(error));

export const signOut = async () => await Auth.signOut({ global: true });

export function openCheckout(
  payload,
  amount,
  order_id,
  showLoader,
  cachedCart
) {
  let rzp = new window.Razorpay({
    key: RAZORPAY_CONSTANTS.KEY_ID,
    amount,
    name: "Sindhi Dry Fruits",
    description: `Processing Fee: ${payload["processing_fee"]}`,
    callback_url: `${AWS_CONSTANTS.API_URL}v1/orders/complete?amount=${amount}`,
    order_id,
    modal: {
      ondismiss: () => {
        updateCartCache(cachedCart, true);
        deleteOrderByRazorpayOrderId(order_id);
        document
          .getElementsByTagName("body")[0]
          .style.removeProperty("overflow");
        showLoader(false);
      },
    },

    prefill: {
      name: payload.user_attributes.given_name,
      email: payload.user_attributes.email,
      contact: payload.user_attributes.username,
    },
  });
  rzp.open();
}

export const validateCoupon = async (couponCode) =>
  await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/coupons?coupon=${couponCode}`)
    .then(() => true);

export const validateSuperAdmin = async (email, password) =>
  await axios
    .post(`${AWS_CONSTANTS.API_URL}v1/superadmin`, { email, password })
    .then(() => true)
    .catch(() => false);

export const createOrder = async (payload) =>
  await axios
    .post(`${AWS_CONSTANTS.API_URL}v1/orders`, payload)
    .then((result) => result.data);

export const getShippingCharges = async (requestBody) =>
  await axios
    .post(`${AWS_CONSTANTS.API_URL}v1/shippingamount`, requestBody)
    .then((result) => result.data.data.shippingPrice);

export const updateShowPriceValue = async (value) =>
  await axios
    .put(`${AWS_CONSTANTS.API_URL}v1/showprice`, { show_price: String(value) })
    .then(() => true)
    .catch((error) => alert(error.response.data.error));

export const getOrders = async (queryParams = {}) => {
  queryParams["perPage"] = 20;
  !queryParams["pageNo"] && (queryParams["pageNo"] = 1);
  var query = "";
  if (Object.keys(queryParams).length > 0) {
    query = new URLSearchParams();
    Object.keys(queryParams).forEach(
      (element) =>
        queryParams[element] !== null &&
        query.append(element, queryParams[element])
    );
  }
  return await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/orders?${query}`)
    .then((result) => result.data.data)
    .catch((error) => alert(error.response.data.error));
};

export const getSubCategories = async () =>
  await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/subcategories`)
    .then((result) => result.data.data.subcategory_names)
    .catch((error) => alert(error.response.data.error));

export function getCartQuantityFromProductId(cart, product) {
  let retval = null;
  if (product.rate_amt) {
    retval = [];
    cart.forEach(
      (element) =>
        element.product_id === product.product_id &&
        retval.push({
          packaging: element.packaging,
          quantity: element.quantity,
        })
    );

    retval.length === 0 &&
      retval.push({
        packaging: product.default_packaging,
        quantity: 0,
      });
  } else {
    const index = cart.findIndex(
      (element) => element.product_id === product.product_id
    );
    if (index >= 0) {
      retval = cart[index].quantity;
    }
  }

  return retval;
}

export const productPackagingInCart = (productQuantity) => {
  const retval = [];
  productQuantity.forEach(
    (element) =>
      !retval.includes(element.packaging) && retval.push(element.packaging)
  );
  return retval;
};

export function updateCartCache(cart, remove = null) {
  remove && eraseCookie("cart");
  cart !== null && setCookie("cart", JSON.stringify(cart));
}

export const getCartCache = () => {
  try {
    return JSON.parse(getCookie("cart")) || [];
  } catch (error) {
    console.log("error here: ", error);
    eraseCookie("cart");
    return [];
  }
};

function setCookie(name, value, days = 700) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    (value || "") +
    expires +
    "; path=/" +
    "; SameSite=None; Secure";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export const eraseCookie = (name) =>
  (document.cookie =
    name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");

export const getAddressObjectFromAddressComponents = (address_components) => {
  const address = {
    addressLine1: null,
    city: null,
    state: null,
    pincode: null,
  };
  for (var i = 0; i < address_components.length; i++) {
    if (address_components[i].types.includes("postal_code")) {
      address.pincode = address_components[i].long_name;
    } else if (address_components[i].types.includes("country")) {
      continue;
    } else if (
      address_components[i].types.includes("administrative_area_level_1")
    ) {
      address.state = address_components[i].long_name;
    } else if (address_components[i].types.includes("locality")) {
      address.city = address_components[i].long_name;
    } else {
      if (address.addressLine1 === null) {
        address.addressLine1 = "";
      }
      address.addressLine1 += `${address_components[i].long_name} `;
    }
  }
  return address;
};

export const getCurrentLocation = async () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(function (position) {
      resolve({
        lat: position.coords.latitude,
        long: position.coords.longitude,
      });
    });
  });

export const updatePriority = async (categoryId, priority) =>
  await axios
    .patch(`${AWS_CONSTANTS.API_URL}v1/categories/priority`, {
      category_id: categoryId,
      priority,
    })
    .then(() => true);

export const processRefund = async (razorpay_payment_id, amount) =>
  await axios
    .post(
      `https://api.razorpay.com/v1/payments/${razorpay_payment_id}/refund`,

      { amount: amount },
      {
        headers: { "Access-Control-Allow-Origin": "*" },
        auth: {
          username: RAZORPAY_CONSTANTS.KEY_ID,
          password: RAZORPAY_CONSTANTS.SECRET_ID,
        },
      }
    )
    .then(() => true);

export function object_equals(x, y) {
  if (x === y) return true;
  // if both x and y are null or undefined and exactly the same

  if (!(x instanceof Object) || !(y instanceof Object)) return false;
  // if they are not strictly equal, they both need to be Objects

  if (x.constructor !== y.constructor) return false;
  // they must have the exact same prototype chain, the closest we can do is
  // test there constructor.

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue;
    // other properties were tested using x.constructor === y.constructor

    if (!y.hasOwnProperty(p)) return false;
    // allows to compare x[ p ] and y[ p ] when set to undefined

    if (x[p] === y[p]) continue;
    // if they have the same strict value or identity then they are equal

    if (typeof x[p] !== "object") return false;
    // Numbers, Strings, Functions, Booleans must be strictly equal

    if (!object_equals(x[p], y[p])) return false;
    // Objects and Arrays must be tested recursively
  }

  for (p in y) if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
  // allows x[ p ] to be set to undefined

  return true;
}

export const deleteProduct = async (productId, name) =>
  window.confirm(
    `Are you sure you want to delete this product: ${name}. This cannot be undone`
  )
    ? await axios
        .delete(`${AWS_CONSTANTS.API_URL}v1/products/${productId}`)
        .then(() => true)
        .catch((error) => alert(error.response.data.error))
    : false;

export const insertProduct = async (data) =>
  window.confirm(
    `Are you sure you want to insert this product and its data: ${data.product_name}`
  )
    ? await axios
        .post(`${AWS_CONSTANTS.API_URL}v1/products`, data)
        .then(() => {
          alert("Product Inserted Successfully");
          return true;
        })
        .catch((error) => alert(error.response.data.error))
    : false;

export const updateProduct = async (id, data) =>
  window.confirm(
    `Are you sure you want to update this product ${data.product_name}`
  )
    ? await axios
        .patch(`${AWS_CONSTANTS.API_URL}v1/products/${id}`, data)
        .then(() => {
          alert("Product data updated successfully");
          return true;
        })
        .catch((error) => alert(error.response.data.error))
    : false;

export const validateData = (data) => {
  if (
    data.product_name === null ||
    data.product_name === "" ||
    !data.product_name === undefined
  ) {
    alert("Product Name cannot be empty");
    return;
  } else if (
    (data.rate_amt === null && data.price_fixed === null) ||
    (data.rate_amt === undefined && data.price_fixed === undefined)
  ) {
    alert("Please enter either a rate amount or a fixed price for the product");
    return;
  } else if (
    (data.rate_amt === null || data.rate_amt === undefined) &&
    data.price_fixed
  ) {
    if (data.weight === null || data.weight === undefined) {
      alert("Weight is mandatory when the price is fixed");
      return;
    }
    if (data.unit === null || data.unit === undefined) {
      alert("Unit is mandatory when the price is fixed");
      return;
    }
  } else if (
    data.rate_amt &&
    (data.price_fixed === null || data.price_fixed === undefined)
  ) {
    if (data.weight) {
      alert("Weight cannot be added in a product containing Rate Amount");
      return;
    }
    if (data.unit) {
      alert("Unit cannot be added in a product containing Rate Amount");
      return;
    }
    if (
      data.product_packaging === null ||
      data.product_packaging === undefined
    ) {
      alert("Product packaging is mandatory when the price is in rate amount");
      return;
    }
    if (
      data.default_packaging === null ||
      data.default_packaging === undefined
    ) {
      alert("Default packaging is mandatory when the price is in rate amount");
      return;
    }
  } else if (
    (data.rate_amt !== null && data.price_fixed !== null) ||
    (data.rate_amt !== undefined && data.price_fixed !== undefined)
  ) {
    alert(
      "Fixed Price and Rate Amount are not allowed together. Please remove one"
    );
    return;
  } else if (data.unit === null || data.unit === undefined) {
    alert("Unit selection is mandatory");
    return;
  } else if (data.category_id === null || data.category_id === undefined) {
    alert("Please select a category");
    return;
  } else if (data.sub_category === null || data.sub_category === undefined) {
    alert("Please enter a sub category");
    return;
  } else if (data.tax === null || data.tax === undefined) {
    alert("Please enter tax");
    return;
  } else if (data.hsn === null || data.hsn === undefined) {
    alert("Please enter HSN");
    return;
  }
  if (
    data.category_id === null ||
    data.category_id === "" ||
    data.category_id === undefined
  ) {
    alert("Category cannot be empty");
    return;
  }
  if (
    data.sub_category === null ||
    data.sub_category === "" ||
    data.sub_category === undefined
  ) {
    alert("Sub category cannot be empty");
    return;
  }
  return true;
};

export function getCategoryNameFromId(categories, categoryId) {
  const retval = categories.filter(
    (element) => categoryId === element.category_id
  );
  return retval[0].category_name;
}

export const getShippingNumber = (username) =>
  username.startsWith("+91")
    ? username.substring(3, username.length)
    : username;

export const isOrderDeliverable = (products) => {
  for (var i = 0; i < products.length; i++) {
    if (products[i].courier_svc === false) {
      return false;
    }
  }
  return true;
};

export const generateInvoice = async (order) => {
  var AWS = require("aws-sdk");
  var lambda = new AWS.Lambda({
    accessKeyId: AWS_CONFIG.ACCESS_KEY_ID,
    secretAccessKey: AWS_CONFIG.SECRET_KEY_ID,
    region: "ap-south-1",
  });
  await lambda
    .invoke({
      FunctionName: "CustomerInvoice", // the lambda function we are going to invoke
      InvocationType: "RequestResponse",
      Payload: JSON.stringify({ body: order, id: order.order_id }),
    })
    .promise();
};

export const downloadInvoice = async (order) => {
  const aws = require("aws-sdk");
  let s3 = new aws.S3({
    accessKeyId: AWS_CONFIG.ACCESS_KEY_ID,
    secretAccessKey: AWS_CONFIG.SECRET_KEY_ID,
    region: "ap-south-1",
  });
  console.log("Order: ", order);
  const exists = await s3
    .headObject({
      Bucket: AWS_CONSTANTS.ASSET_BUCKET_NAME,
      Key: `invoices-backend/${order.order_id}/${order.order_id}.pdf`,
    })
    .promise()
    .then(
      () => true,
      async (err) => {
        const regenerate = err.code === "NotFound";
        if (["Payment Incomplete", "Failed"].includes(order.order_status)) {
          regenerate &&
            alert("Invoice Doesnot exist. Generating invoice. Please wait.");
          regenerate &&
            (await generateInvoice(order).then(() =>
              createDownload(s3, order.order_id)
            ));
        } else {
          alert(
            "The invoice is being generated. Please wait and try again later"
          );
        }
      }
    );

  exists && (await createDownload(s3, order.order_id));
};

const createDownload = async (s3, order_id) => {
  await s3
    .getObject({
      Bucket: AWS_CONSTANTS.ASSET_BUCKET_NAME,
      Key: `invoices-backend/${order_id}/${order_id}.pdf`,
    })
    .promise()
    .then((data) => {
      let blob = new Blob([data.Body], { type: data.ContentType });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${order_id}.pdf`;
      link.click();
    })
    .catch((error) => alert(error.response.data.error));
};

export const cancelOrder = async (orderId, data) =>
  await axios
    .patch(`${AWS_CONSTANTS.API_URL}v1/orders/${orderId}/cancel`, data)
    .then((result) => result.data)
    .catch((error) => alert(error.response.data.error));

export const cacheCancelVideoTutorial = (value) =>
  setCookie("showTutorial", `${value}`, 365);

export const getShowVideoTutorial = () => {
  const retval = getCookie("showTutorial");
  return retval && retval === "false" ? false : true;
};

export const getDefaultAddressIndex = (addresses) => {
  for (var i = 0; i < addresses.length; i++) {
    if (addresses[i].defaultAddress) {
      return i;
    }
  }
};

export const updateUserPoolAttributes = async (user, paylaod) =>
  Auth.updateUserAttributes(user, paylaod);

export const updateUserAddress = async (address) =>
  await Auth.currentAuthenticatedUser()
    .then((user) => updateUserPoolAttributes(user, { address }))
    .then((result) => result);

export const userHasAddress = (confirmAddress, addresses) => {
  for (var i = 0; i < addresses.length; i++) {
    if (object_equals(confirmAddress, addresses[i])) {
      return i;
    }
  }
  return null;
};

export const verifyCurrentUserAttributePool = async (type) =>
  Auth.verifyCurrentUserAttribute(type);

export const verifyCurrentUserAttributeSubmitPool = async (type, code) =>
  Auth.verifyCurrentUserAttributeSubmit(type, code);

export const getCurrentUserAddress = async () =>
  await Auth.currentAuthenticatedUser().then((user) =>
    JSON.parse(user.attributes.address)
  );

export const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const getWeightText = (weight) =>
  weight >= 1000 ? `${weight / 1000} KG` : `${weight} GMS`;

export const getStorePickupData = async () =>
  await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/storepickup`)
    .then((result) => result.data.data)
    .catch((error) => {
      alert(error.response.data.error);
      return null;
    });

export const updateStorePickupCounter = async (value) =>
  await axios
    .put(`${AWS_CONSTANTS.API_URL}v1/storepickup`, { counter: value })
    .then(() => true)
    .catch((error) => {
      alert(error.response.data.error);
      return false;
    });

const isAfter630 = (date) => date.getHours() >= 18;

export const getStorePickupStartAndEndDate = (storePickupCounter) => {
  let startDate = new Date();
  if (storePickupCounter > 0) {
    startDate = new Date(startDate.setHours(0, 0, 0, 0));
    let endDate = new Date(startDate);
    startDate.setDate(startDate.getDate() + storePickupCounter);
    endDate.setDate(startDate.getDate() + 14);
    return { startDate, endDate };
  }
  if (isAfter630(startDate)) {
    startDate.setDate(startDate.getDate() + 1);
    startDate.setHours(0, 0, 0, 0);
  }
  return {
    startDate,
    endDate: new Date().setDate(startDate.getDate() + 14),
  };
};

export const updateStorePickupTiming = async (pickupSlot, status) =>
  await axios
    .put(`${AWS_CONSTANTS.API_URL}v1/storepickupslot`, {
      pickupSlot,
      status,
    })
    .then(() => true)
    .catch((error) => {
      alert(error.response.data.error);
      return false;
    });

export const formatAMPM = (hours) => {
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  var strTime = hours + ampm;
  return strTime;
};

export const isToday = (date1) =>
  date1.getFullYear() === new Date().getFullYear() &&
  date1.getMonth === new Date().getMonth &&
  date1.getDate() === new Date().getDate();

export const getActiveSlots = (storePickupSlots) => {
  const activeSlots = [];
  for (var j = 0; j < storePickupSlots.length; j++) {
    storePickupSlots[j].status &&
      activeSlots.push(storePickupSlots[j].store_pickup_timings);
  }
  return activeSlots;
};

export const getStorePickupSlotsFromTime = (hour, activeSlots) => {
  const retval = [];
  for (var i = hour; i < 24; i += 1) {
    const val = `${formatAMPM(i)}-${formatAMPM(i + 1)}`;
    activeSlots.includes(val) &&
      retval.push(`${formatAMPM(i)}-${formatAMPM(i + 1)}`);
  }
  return retval;
};

export const sendPassword = async (email, given_name, username) =>
  await axios
    .post(`${AWS_CONSTANTS.API_URL}v1/password`, {
      email,
      given_name,
      username,
    })
    .then((result) => result.data.message);

export const packOrder = async (orderId) =>
  await axios
    .patch(`${AWS_CONSTANTS.API_URL}v1/orders/${orderId}/pack`)
    .then(() => true);

export const isMyScriptLoaded = (url) => {
  var scripts = document.getElementsByTagName("script");
  for (var i = scripts.length; i--; ) {
    if (scripts[i].src === url) return true;
  }
  return false;
};

export const getTotalQuantity = (productQuantity) => {
  let retval = 0;
  if (productQuantity) {
    for (var i = 0; i < productQuantity.length; i++) {
      retval += productQuantity[i].packaging * productQuantity[i].quantity;
    }
  }
  return retval;
};

export const isSuperAdminLoggedIn = () => {
  const adminCookie = getCookie("adminLoginDate");
  return adminCookie && adminCookie === "true";
};

export const setSuperAdminLoginDate = () =>
  setCookie("adminLoginDate", "true", 730);

export const removeSuperAdminLoginDate = () => eraseCookie("adminLoginDate");

export const getProductAmountInCart = (element) =>
  element.rate_amt
    ? round(
        element.quantity * ((element.rate_amt / 1000) * element.packaging),
        0
      ).toFixed(0)
    : `${element.quantity * element.price_fixed}`;

export const isInViewport = (id, offset = 0) => {
  try {
    const container = document.getElementsByClassName("sub-category-tabs")[0];
    const { x, width } = document.getElementById(id).getBoundingClientRect();
    const containerWidth = container.getBoundingClientRect().width;
    if (containerWidth + 50 < x + width) {
      return 1;
    } else if (x < 0) {
      return 2;
    }
    return 0;
  } catch (error) {
    return 0;
  }
};

export const dispatchOrder = async (id, payload) =>
  await axios
    .post(`${AWS_CONSTANTS.API_URL}v1/orders/${id}/dispatch`, payload)
    .then(() => {
      alert("Order dispatch has been created successfully");
      return true;
    })
    .catch((error) => {
      alert(error.response.data.error);
      return false;
    });

export const getDeliveryState = async () =>
  await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/deliverystatus`)
    .then((result) => result.data.data)
    .catch((error) => alert(error.response.data.error));

export const updatetDeliveryState = async (value) =>
  await axios
    .put(`${AWS_CONSTANTS.API_URL}v1/deliverystatus`, {
      delivery_status: value,
    })
    .then(() => {
      alert("Changed Successfully");
      return true;
    })
    .catch((error) => alert(error.response.data.error));

export const getDelhiveryRequestPickupShipmentCount = async () =>
  await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/deliverypickup/count`)
    .then((result) => result.data.data)
    .catch((error) =>
      alert(
        `${error.response.data.error}. Please enter the number of shipments manually`
      )
    );

export const createDelhiveryRequestPickup = async (payload) => {
  console.log("Payload here: ", payload);
  return await axios
    .post(
      "https://cors-anywhere.herokuapp.com/https://track.delhivery.com/fm/request/new/",
      payload,
      {
        headers: {
          Authorization: `Token ${DELHIVERY_CONFIG.TOKEN}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    )
    .then(() => true)
    .catch((error) => {
      error && error.response && alert(JSON.stringify(error.response.data));
      return false;
    });
};

export const getDataDeletionStatus = async (id) =>
  await axios
    .get(`${AWS_CONSTANTS.API_URL}v1/deletion/${id}`)
    .then((result) => result.data);

export const handleFederatedAuthentication = async (provider) =>
  await Auth.federatedSignIn({ provider });

export const checkDuplicatePhoneNumberUser = async (username) => {
  const aws = require("aws-sdk");
  let cognitoIdentityServiceProvider = new aws.CognitoIdentityServiceProvider({
    accessKeyId: AWS_CONFIG.ACCESS_KEY_ID,
    secretAccessKey: AWS_CONFIG.SECRET_KEY_ID,
    region: "ap-south-1",
  });
  return await cognitoIdentityServiceProvider
    .listUsers({
      Filter: `phone_number = "${username}"`,
      UserPoolId: AWS_CONFIG.COGNITO_USER_POOL_ID,
    })
    .promise();
};
